import { useState } from "react";
import { api } from "../lib/api";
import { useTelegram } from "../hooks/useTelegram";
import { Loader2, Sparkles, Calendar } from "lucide-react";

export function ProfilePage() {
  const { user, webApp } = useTelegram();
  const [loading, setLoading] = useState<"monthly" | "yearly" | null>(null);
  const [digestLoading, setDigestLoading] = useState(false);
  const [digest, setDigest] = useState<any>(null);

  async function buy(plan: "monthly" | "yearly") {
    setLoading(plan);
    try {
      const res = await api.createInvoice(plan);
      // Open invoice in Telegram
      if (webApp && (webApp as any).openInvoice) {
        (webApp as any).openInvoice(res.invoice_url, (status: string) => {
          if (status === "paid") {
            alert("Спасибо! Pro активирован.");
          }
        });
      } else {
        // Fallback: open link
        window.open(res.invoice_url, "_blank");
      }
    } catch (e: any) {
      alert(e.message || "Ошибка создания счёта");
    } finally {
      setLoading(null);
    }
  }

  async function genDigest() {
    setDigestLoading(true);
    try {
      const res = await api.generateDigest("daily");
      setDigest(res.digest);
    } catch (e: any) {
      alert(e.message);
    } finally {
      setDigestLoading(false);
    }
  }

  return (
    <div className="px-4 pt-4 pb-28">
      <h1 className="text-xl font-bold mb-1">Профиль</h1>
      <p className="text-white/50 text-sm mb-6">
        {user?.first_name || "Пользователь"}
        {user?.username ? ` · @${user.username}` : ""}
      </p>

      {/* Subscription */}
      <section className="bg-surface-card border border-white/5 rounded-2xl p-5 mb-6">
        <div className="flex items-center gap-2 mb-3">
          <Sparkles size={18} className="text-accent" />
          <h2 className="font-semibold">Cortex Pro</h2>
        </div>
        <p className="text-sm text-white/60 mb-4">
          Безлимит заметок, проекты, граф связей, дайджесты и приоритет AI.
        </p>
        <div className="grid grid-cols-2 gap-3">
          <button
            onClick={() => buy("monthly")}
            disabled={!!loading}
            className="bg-accent/20 hover:bg-accent/30 border border-accent/40 rounded-xl py-3 text-sm font-medium transition"
          >
            {loading === "monthly" ? (
              <Loader2 size={16} className="animate-spin mx-auto" />
            ) : (
              <>150 ⭐ / мес</>
            )}
          </button>
          <button
            onClick={() => buy("yearly")}
            disabled={!!loading}
            className="bg-accent hover:bg-accent-soft rounded-xl py-3 text-sm font-medium transition"
          >
            {loading === "yearly" ? (
              <Loader2 size={16} className="animate-spin mx-auto" />
            ) : (
              <>900 ⭐ / год</>
            )}
          </button>
        </div>
        <p className="text-[11px] text-white/30 mt-3 text-center">
          Оплата через Telegram Stars
        </p>
      </section>

      {/* Digest */}
      <section className="bg-surface-card border border-white/5 rounded-2xl p-5 mb-6">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Calendar size={18} className="text-accent" />
            <h2 className="font-semibold">Дайджест</h2>
          </div>
          <button
            onClick={genDigest}
            disabled={digestLoading}
            className="text-xs text-accent font-medium"
          >
            {digestLoading ? "Генерирую..." : "Сгенерировать"}
          </button>
        </div>

        {digest?.content && (
          <div className="space-y-3 text-sm">
            {digest.content.main?.length > 0 && (
              <div>
                <p className="text-white/40 text-xs mb-1">Главное</p>
                <ul className="list-disc list-inside text-white/80 space-y-1">
                  {digest.content.main.map((t: string, i: number) => (
                    <li key={i}>{t}</li>
                  ))}
                </ul>
              </div>
            )}
            {digest.content.tasks?.length > 0 && (
              <div>
                <p className="text-white/40 text-xs mb-1">Задачи</p>
                <ul className="list-disc list-inside text-white/80 space-y-1">
                  {digest.content.tasks.map((t: string, i: number) => (
                    <li key={i}>{t}</li>
                  ))}
                </ul>
              </div>
            )}
            {digest.content.ideas?.length > 0 && (
              <div>
                <p className="text-white/40 text-xs mb-1">Идеи</p>
                <ul className="list-disc list-inside text-white/80 space-y-1">
                  {digest.content.ideas.map((t: string, i: number) => (
                    <li key={i}>{t}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        {!digest && (
          <p className="text-white/40 text-sm">
            Нажми «Сгенерировать», чтобы получить выжимку за день
          </p>
        )}
      </section>

      <p className="text-xs text-white/25 text-center">Cortex v0.2.0</p>
    </div>
  );
}